import {
  formatDate, getTimeGreeting
} from '@/common/js/utils';
import {
  computed
} from '@vue/composition-api';
import store from '@/store/index';

/**
 * @description 根据时间生成问候语，例如：1.下午好。2.下午好，今天是9月14日
 * @param {boolean} [isDate=true] 是否需要带上日期字符串
 * @returns
 */
export default function useGetNote(isDate = true) {
  const note = computed(() => {
    const dateObj = store.state.currentDateObj || new Date();

    const greetings = getTimeGreeting(dateObj.getHours());

    if (isDate) {
      const dateStr = formatDate(dateObj, false);
      return `${greetings}，今天是${dateStr}`;
    }

    return `${greetings}`;
  });

  return {
    note
  };
}
